import { FC } from 'react'
import type { AwardsModuleHomePage } from '../../../types/components'
import ModuleAwardsPageComponent from '../ModuleAwardsPage'
import { ApiPagePage } from '../../../types/contentTypes'

const ModuleAwardsHomePage: FC<{
  moduleProps: AwardsModuleHomePage['attributes']
  landingContentData: ApiPagePage['attributes']
}> = ({ moduleProps }) => {
  return <ModuleAwardsPageComponent moduleProps={moduleProps} />
}

export default ModuleAwardsHomePage
